
const gConst = {
    "APP_ID": "DCP",
    "APP_NAME": "DiscoveringChinesePro",
    "SYS_TYPE": 1,
    "BOOK_CATEGORY_ID": 3,
    "BUNDLE_ID": "com.betterchinese.DCP",
    "iTUNES_APP_ID": "650727943", // DCP 的
    // // WS Call Error No
    // "WS_SYNC_CALL_ERR_NO_FAILURE": -1,
    // "WS_SYNC_CALL_ERR_NO_FAILURE_TIMEOUT": -2,
    // "WS_SYNC_CALL_ERR_NO_SUCCESS_ERROR": -3,
    // "WS_SYNC_CALL_ERR_NO_SUCCESS_NO_RESPONSE_TEXT": -4,
    // "WS_SYNC_CALL_ERR_NO_SUCCESS": 1,

    // #region Action - Web Call App

    "ACTION_AUDIO_RECORD": 1,
    "ACTION_LOGIN": 19,
    "ACTION_LOGOUT": 4,
    "ACTION_SAVE_ENCRIPTED_DATA": 7,
    "ACTION_GET_ENCRIPTED_DATA": 8,
    "ACTION_VIDEO_RECORD": 9,
    "ACTION_OPEN_BROWSER": 10,

    "ACTION_OPEN_SPEECH_RECOGNITION": 11,
    "ACTION_START_SR_RECORDING": 12,
    "ACTION_STOP_SR_RECORDING": 28,
    "ACTION_ABORT_SR_RECORDING": 29,
    "ACTION_CLOSE_SPEECH_RECOGNITION": 13,
    "ACTION_OPEN_PDF": 18,
    "ACTION_SHARE_FILE_WITH_ANOTHER": 40,
    "ACTION_OPEN_SAFARI_VIEW": 59,              // OpenSafariView Tim23.07.06

    // OAuth
    // "ACTION_OAUTH_FB_REG": 36, // Facebook Registration
    // "ACTION_OAUTH_FB_LOGOUT": 37, // Facebook Logout
    "ACTION_OAUTH_GOOGLE_REG": 38, // Google Registration
    "ACTION_OAUTH_GOOGLE_LOGOUT": 39, // Google Logout
    "ACTION_OAUTH_APPLE_REG": 43, // Login with Apple
    "ACTION_CHECK_APPLE_LOGIN_VERIFY": 44, // Check Apple Login Verify
    "ACTION_OEPN_APP_SHARE_WITH_URL": 46, // Open App Share with Url Type (目前做給 Share to Google Classroom)     // Add Richard20.04.13  // 幫忙註解 Tim20.04.13
    "ACTION_OPEN_ANOTHER_APP_BY_URL_SCHEMES": 53,
    "ACTION_InAppPurchaseWIthProductID": 54, // 新版 SiwftUI的版本
    "ACTION_START_AUDIO_RECORDING": 55,// 新版 SiwftUI的版本
    "ACTION_STOP_AUDIO_RECORDING": 56,// 新版 SiwftUI的版本

    "ACTION_GET_LESSON_DEF": 101, // 只有舊版Swift使用
    "ACTION_GET_BOOK_DEF": 102, // 只有舊版Swift使用
    "ACTION_OPEN_DCP_ASSESSMENT": 109, // 只有舊版Swift使用
    "ACTION_GET_GLOSSARY_DEF": 125, // 只有舊版Swift使用
    "ACTION_GET_HOMEWORK_DEF": 126, // 只有舊版Swift使用
    "ACTION_GET_PRELUDE": 137, // 只有舊版Swift使用
    "ACTION_OPEN_IAP": 138, // 只有舊版Swift使用
    "ACTION_SAVE_IMAGE_TO_LIBRARY": 140,

    // #endregion Action - Web Call App

    // #region Action - App Call Web

    "ACTION_APP_TO_BACKGROUND": 2,
    "ACTION_APP_TO_FOREGROUND": 3,
    "ACTION_APP_SPEECH_RECOGNITION": 5,
    "ACTION_IN_APP_PURCHASE_RESULT": 19,
    "ACTION_SOUND_POWER": 20,
    "ACTION_AUDIO_RECORDING_RESULT": 21,      // 單純錄音
    "ACTION_LAUNCH_BY_RELATED_APP": 112,
    "ACTION_IAP_RESULT": 115,               // 用來收到IAP與Apple溝通後，最後的結果處理     Tim

    // #endregion Action - App Call Web

    // Class Account Role
    "CLASS_ACCOUNT_ROLE_PERSONAL": 0,
    "CLASS_ACCOUNT_ROLE_TEACHER": 1,
    "CLASS_ACCOUNT_ROLE_STUDENT": 2,


    // WS return error code
    "WS_RETURN_ERR_CREDENTIAL_NOT_EXIST": -110102,                          // CREDENTIAL(認證) 不存在
    "WS_RETURN_ERR_CREDENTIAL_EXPIRED": -110103,                            // CREDENTIAL(認證) 過期
    "WS_RETURN_ERR_CREDENTIAL_NORMAL_LOGOUT": -110104,                      // CREDENTIAL(認證) 一般登出
    "WS_RETURN_ERR_CREDENTIAL_NEW_SESSION_LOGIN": -110105,                  // CREDENTIAL(認證) 輸入帳密 後踢前
    "WS_RETURN_ERR_CREDENTIAL_OSS_TOOL": -110106,                           // 客服阻擋
    "WS_RETURN_ERR_CREDENTIAL_CALLED_SN_TOO_OLD": -110107,                  // CREDENTIAL(認證) 封包序號順序不對
    "WS_RETURN_ERR_CREDENTIAL_ANOTHER_USER_IN_THE_SAME_CLINET": -110108,    // CREDENTIAL(認證) 認證登入 後踢前    // 目前後端統一傳 -110105，所以-110108不會發生 Tim17.06.15
    "WS_RETURN_ERR_CREDENTIAL_CLOSED_BY_UNKNOWN": -110109,                  // Closed by default value      // Add Tim16.03.31

    // Web Gateway return error code
    "WEB_GATEWAY_RETURN_ERR_CREDENTIAL_NOT_EXIST": -140010,
    "WEB_GATEWAY_RETURN_ERR_CREDENTIAL_EXPIRED": -140005,
    "WEB_GATEWAY_RETURN_ERR_CREDENTIAL_NORMAL_LOGOUT": -140006,
    "WEB_GATEWAY_RETURN_ERR_CREDENTIAL_NEW_SESSION_LOGIN": -140007,
    "WEB_GATEWAY_RETURN_ERR_CREDENTIAL_OSS_TOOL": -140008,
    "WEB_GATEWAY_RETURN_ERR_CREDENTIAL_CALLED_SN_TOO_OLD": -140009,
    "WEB_GATEWAY_RETURN_ERR_CREDENTIAL_ANOTHER_USER_IN_THE_SAME_CLINET": -140066,
    "WEB_GATEWAY_RETURN_ERR_CREDENTIAL_CLOSED_BY_UNKNOWN": -140067,         // Add Tim16.03.31
    "WEB_GATEWAY_RETURN_ERR_CREDENTIAL_FAILED_UNKNOWN": -140070,


    "WEB_GATEWAY_RETURN_ERR_RESET_FORGOT_PASSWORD_COULDNOT_FIND": -140068,                  // ResetForgotPassword: 
    "WEB_GATEWAY_RETURN_ERR_RESET_FORGOT_PASSWORD_NOT_ALLOWED_CHANGE_PASSWORD": -140180,    // 155 ResetForgotPassword:     帳戶不允許更改密碼

    "WEB_GATEWAY_RETURN_ERR_RESET_FORGOT_PASSWORD_NOT_YET_CLICK_VERIFY_LINK": -140171,      // ResetForgotPassword:     沒點選 認證連結
    "WEB_GATEWAY_RETURN_ERR_RESET_FORGOT_PASSWORD_EMAIL_NOT_VERIFIED": -140181,             // ResetForgotPassword:     沒認證Email
    "WEB_GATEWAY_RETURN_ERR_RESET_FORGOT_PASSWORD_EMAIL_NOT_EXISTED": -140182, 


    "WEB_GATEWAY_RETURN_ERR_LOGIN_NOT_ACTIVATED_YET": -140061, // 114 Login not activated (email)  帳號註冊完未點mail啟用   (需新註冊帳號重現)
    "WEB_GATEWAY_RETURN_ERR_LOGIN_INACTIVE": -140062, // 118 account inactive             帳號在班級被關閉         (Class Management 可開關)
    "WEB_GATEWAY_RETURN_ERR_LOGIN_MISMATCH": -140063, // 115 Login: username password mismatched
    "WEB_GATEWAY_RETURN_ERR_LOGIN_LOGIN_NAME_NOT_EXIST": -140170, // 152 Login: login name not exist. 帳號不存在
    "WEB_GATEWAY_RETURN_ERR_LOGIN_PASSWORD_NOT_MATCH": -140179, // 108 Login: password not match.   密碼錯誤

    "WEB_GATEWAY_RETURN_ERR_CREATE_USER_REPEAT": -140157,                   // 註冊帳號重複                

    // Web Gateway return error code
    "WEB_GATEWAY_RETURN_ERR_UNKNOWN_FUNCTION": -140001,
    
    // Verify Email
    "WEB_GATEWAY_RETURN_ERR_VE_EXIST_EMAIL_WITH_OTHER_ACCOUNTID": -140186,  // 你輸入的信箱已存在 158
    "WEB_GATEWAY_RETURN_ERR_VE_NOT_YET_CLICK_VERIFY_LINK": -140171,         // 再次寄送認證信到你的信箱 153
    "WEB_GATEWAY_RETURN_ERR_VE_ALREADY_VERIFIED": -140172,                  // 此連結已驗證過 154

    "RECEIPT_NOT_VALID": -120063,                                           // 購買 收據無效
    "SOMEBODY_IS_REUSING_A_RECEIPT": -120064,                               // 購買 收據重複
    "RECEIPT_PRODUCT_ID_ERROR": -120065,                                    // 購買 收據ID錯誤
    "AUTHORIZATION_DEFAULT_ERROR": -120057,                                 // 購買 預設未定義錯誤
    "AUTHORIZATION_NOT_RESPONSE": -120058,                                  // 購買 收到錯誤訊息的預設錯誤

    // 輸入授權碼 錯誤
    "WEB_GATEWAY_RETURN_ERR_AUTH_PROVISIONING_PROVISONED": -120055,         // 已被開通 
    "WEB_GATEWAY_RETURN_ERR_AUTH_PROVISIONING_EXPIRED": -120056,            // 已過期


    // 滑動參數
    "SWIPE_DIST_THRESHOLD": 100,    // 滑動最小距離
    "SWIPE_MS_THRESHOLD": 300,      // 滑動時間

    "MIN_CLIENT_HEIGHT": 720,

    // error message place holder
    "ERR_MSG_PLACEHOLDER": "_?_",

    // 錄音功能 Safari 偏移座標
    "AUDIO_REC_SAFARI_OFFSET_TOP": -10000,
    // "WAR_ERROR_INIT_SETTING_ALLOW_MICROPHONE_ACCESS": -3001,    // Network Timeout
    // "WAR_ERROR_INIT_DETECT_MICROPHONE": -1, 

    // ImgVerPostfix
    "IMG_VER_POSTFIX": "?ImgVer=",      // 解決圖片暫存，圖片版號參數 

    "APP_RETURN_ERROR_NETWORK_TIMEOUT": -1001,                  // Network Timeout
    "APP_RETURN_ERROR_NETWORK_OFFLINE": -1002,                  // Netwrok Offline
    "APP_RETURN_ERROR_NETWORK_SERVICE_IS_NOT_REACHABLE": -1003, // Service is not Reachable
    "APP_RETURN_ERROR_CMS_WS_FAILED": -2001,                    // CMS WS failed

    "APP_RETURN_ERROR_APPLE_LOGIN_NOT_SUPPORT_IOS_12": -2,      // Apple Login 不支援 iOS12以下系統

    // "IMAGE_L_WIDTH": 700,
    // "IMAGE_L_HEIGHT": 782,
    // "IMAGE_M_WIDTH": 555,
    // "IMAGE_M_HEIGHT": 771,
    // "IMAGE_S_WIDTH": 550,
    // "IMAGE_S_HEIGHT": 500,

    // "MORE_TOP_SCROLL_ANIMATION_DURATION": 200,

    "TIP_MAX_COUNT": 5,

    "SIGN_IN_WITH_APPLE_APP_VER": "2.0.9.2",    // v2.0.9 b2
    "OPEN_SAFARI_VIEW_APP_VER": "3.1.0.2",      // v3.1.0 b2 新版App 支援 Open Safari View

    "IN_APP_PURCHASE_PRODUCT_ID_VOLUME_01": "APP_DCP_V1_1Y_NON_RENEWING",
    "IN_APP_PURCHASE_PRODUCT_ID_VOLUME_02": "APP_DCP_V2_1Y_NON_RENEWING",
    "IN_APP_PURCHASE_PRODUCT_ID_VOLUME_03": "APP_DCP_V3_1Y_NON_RENEWING",
    "IN_APP_PURCHASE_PRODUCT_ID_VOLUME_04": "APP_DCP_V4_1Y_NON_RENEWING_2",
} // end of gConst

const gSession = {
    "Acc": {
        "ID": 0,        // 0: for Client "APP"
        "LoginName": "",
        "Credential": "",
        "CredentialExpiredTime": null,
        "IsFirstLogin": false,

        // Begin for Login
        "LoginType": -1,
        "Mima4ReLogin": "",
        "IsOAuthLogin": false,
        "OAuthLoginProvider": "",
        // end of for Login

        "Profile":          // get account info 回傳，將來在 settings/account profile 顯示
        {
            "Picture": "",
            "FirstName": "",
            "LastName": "",
            "ClassName": "",
            "Email": "",
            "Gender": 1,
            "Country": 1
        },

        "Class": null,
        "CurrentClassIndex": 0,
        "ClassesBadgeTemp": {               // 新舊版暫存
            "BC2015": null,
            "BCCurrent": null
        },               
        "ClassesBadge": null,               // 班級通知資料
        "VersionAlertList": [],             // LS 不同版本通知紀錄列表

        "Preferences": {
            "Lang": 1 ,                 // gLangTypeEnum.Major 
            "SupportLang": 1,           // 1: English
            "TimeZone": 29,             // 29: UTC+08:00
            "DST": 2,                   // 1.On; 2.Off (default)
            "AutoSync": 1,              // 1.On (default); 2.Off
            "SyncOnlyWhenWiFi": 1,      // 1.Yes (default); 2.No – data cellular is ok
            "DCPContentVersion": 99,    // gContentVerTypeEnum.Ver_Current
            "SRShow": 1                 // DCP 購買提醒 開關 1.On (default); 2.Off
        },
        "EmailVerified": -1, // window.gEmailVerifyEnum.None // 有無 Email認證
        "ParentLetterData": null,
        "TermsData": null,
        "LoginCount": -1,
        "AccountAuthorized": null,
        "LastSyncTime": '',
        "Dashboard": null,
        "OfflineModeIntended": 0,
        // "DataStatusFromLS": 2,       // 1 是 most updated
        "ViewControlRefB4":
        {
            "ControlRef": null
        },
        "ControlsRefInterestInSettings": [],
        "SettingsDirtyFunc": [],
        "FirstLogin": false,
        "ShowTip": false,
        "TipCount": 0,
        "ShowResourcesTip": false,
        // "ResourcesTipCount": 0,          // 與 Cuter討論，此功能 可以拿掉   Tim20.12.31
        "LURecord":
        {
            "Active": false,
            "IsReLogin": false,
            "LessonID": "01001",
            "LUSeqNo": 1,
            "PageIndex": 0
        },
        "AssignmentStatus": [],
        "ClassName4Login": "",
        "NewAssignmentID4GoToLU": -1,    // 直接轉跳過去的 考卷ID
        "SubscriptionReminder": null,
        "ShowGCTip": true,               // Google Classroom 提示      Tim20.06.08
        "ReminderList": null
    },
    "App": {
        "ClearAll": false,
        "InApp": false,
        "Env": "Production",
        // "Env": "Integration",
        // "Env": "Staging",
        // "AppCallbackRef": null,  // richard removed
        "iOSVer": "",
        "BookCatID": 3,             
        "BookSeqNo": 1,             
        "InitAccountID": 0,         // prelude 先使用 AccountID, 暫時不使用Credential
        "InitCredential": "",
        "InitClassName": "",
        "InitLoginName": "",
        "InitOfflineModeIntended": 0,
        "InitLaunchVia": "",
        "InitGotoCreateAccount": false,
        "InitGCShare": "",
        "MinutesOffset": 0,             // 顯示時間 timezone and DST 決定，改變時區
        "MinutesOffsetReality": 0,      // 現實時間 與 UTC 差異的秒數
        "AppVersion": "0.0.0.0",  
        "iOSNewGateway": false, // richard: ios swift UI 不再用 iframe 跟 Web 溝通，用 PostMessage, true:表示iOS是SwiftUI的版本, false:表示iOS是舊的Swift版本

        // ================== Notice BEGIN ==================
        "SubFunc": "",                      // OpenAssignment
        "NoticeNo4AppIcon": 0,              // 沒傳給0
        "AssignmentID": 0,                  // 沒傳給0
        "SubFuncClassID": 0,                // 沒傳給0
        "NoticeNo": 0,                      // 沒傳給0
        // ================== Notice END ==================

        "SysType": 1,                       // 'com.betterchinese.DCP'
        "LoginDevice": 2,                   // 1: inApp, 2: Web
        "DeviceType4LogTrace": 99,          // 裝置類別
        "BrowserType4LogTrace": 99,         // 瀏覽器類別        gBrowserTypeEnum

        "ContentVerType": 99,               // Content Version: 2015, Current...        gContentVerTypeEnum "Ver_2015": 1, "Ver_Current": 99
        "SubFuncContentVerType": 99,        // "Ver_2015": 1, "Ver_Current": 99
        "ResourceType": 1,                  // Textbook：1 Workbook： 2
        
        "BookCategoryDef": null,    // 記得切換 ContentVerType 要清掉
        "BookDef": {
            "01": null,
            "02": null,
            "03": null,
            "04": null
        },      // the keys of content sould be "01", "02", "03", "04" // 記得切換 ContentVerType 要清掉
        "CurrentLesson":  // 記得切換 ContentVerType 要清掉
        {
            "ID": null,
            "Def": null,
            "Status": 0
        },
        "GlossaryDef": null,    // 記得切換 ContentVerType 要清掉,
        "GlossaryStatus": 0,    // 記得切換 ContentVerType 要清掉,
        "HomeworkDef": null,    // 記得切換 ContentVerType 要清掉,
        "PreludeRelativeUrl": "",
        "PreludePrefix": "Lesson_00000",
        "PreludeStatus": 0,
        "InitWindowWidth": 0,
        "InitWindowHeight": 0,
        "OrientationMode": 1,
        "AppIAPResult": false,       // true 需要等 App IAP Result， false 不用處理   Tim17.04.26
        "LoadingMask": [],
        "SRDifficulty": 1,  // Easy
        "PinyinFile": null,
        "WebAudioRecorderCallerRef": null,
        "IsWKWebView": false,
        "DeviceType4Display": 99,
        "StoryVideoCached":
        {
            "LessonID": "",
            "VideoCanPlay": false,
            // "VideoDef": null,
            // "VideoDisplayWidth": 667,
            // "VideoDisplayHeight": 500,
            "VideoDisplayWidthEmbedded": 0,
            "VideoDisplayHeightEmbedded": 0,
            "VideoDisplayWidthFullScreen": 0,
            "VideoDisplayHeightFullScreen": 0,
            "VideoContainerWidth": 0,
            "VideoContainerHeight": 0,
            "VideoElement": null,
            "Keys4Systems": null
        },
        "EventPromotionCallerRef": null,
        "EventPromotionShow": true,
        "LoginAfterStatus": 99,

        // 驗證eMail Code   Tim21.12.21
        "VEData": {
            "UserKey": "",
            "Code": "",
            "EmailAddr": ""
        },
    }
}

const gComponentFuncEntry = {
    "MainRef": null,
    "LessonsRef": null,
    "SRInAppRef": null,
    "SettingsRef": null,
    "GlossaryRef": null,
    "InAppPurchaseRef": null//,
    // SoundPowerRef: null,
    // AudioRecordingResultRef: null
}

const gAppURLSchemes = {
    DCP: "BetterChineseDCP",
    DCPAssessment: "BCDCPAssessment",
    BCLibrary: "BCLibrary",
    AIStoryTime: "aistorytime",
    BetterImmersionNewEdition: "BCBetterImmersionNE",
    BetterImmersionTracker: "BCBIReportNE",
    MCMobile: "mcmobile",
    OLS: "ols"
}

const gAppiTunesURL = {
    DCP: "https://apps.apple.com/us/app/discovering-chinese-pro/id650727943",
    DCPAssessment: "https://apps.apple.com/us/app/apple-store/id908936041",
    BCLibrary: "https://apps.apple.com/us/app/better-immersion-new-edition/id1265008921",
    AIStoryTime: "https://apps.apple.com/us/app/ai-story-time/id1367085119",
    BetterImmersionNewEdition: "https://apps.apple.com/us/app/better-immersion-new-edition/id1265008921",
    BetterImmersionTracker: "https://apps.apple.com/us/app/better-immersion-tracker/id1267703589",
    MCMobile: "https://apps.apple.com/us/app/modern-chinese/id1490548686",
    OLS: "ols"
}

// ========= Enum BEGIN =========
// const gWSServerTypeEnum = {
//     // WS Server Type
//     "WS_BC_LEANING": 1,
//     "WS_WEB_GATEWAY": 2,
//     "WS_WEB_GATEWAY_NODE_JS": 3
// };

// const gDeviceType4LogTraceEnum = {
//     "iPhone": 1,
//     "iPad": 2,
//     "Windows": 3,
//     "MacOS": 4,
//     "ChromeOS": 5,
//     "AndroidPhone": 6,
//     "AndroidTablet": 7,
//     "AndroidDesktopOrLinuxDesktop": 8,
//     "Others": 99
// }

// const gBrowserTypeEnum = {
//     "Safari": 1,
//     "Chrome": 2,
//     "IE": 3,
//     "Firefox": 4,
//     "Silk": 5, //  -> Kindle fire
//     "Edge": 6, //  -> Win 10 New Browser
//     "ChromiumEdge": 7, //  New Edge: Chromium Core
//     "Others": 99
// }

const gAccPreferenceTypeEnum = {
    "Lang": 1 ,
    "SupportLang": 2,
    "TimeZone": 3,
    "DST": 4,
    "AutoSync": 5,
    "SyncOnlyWhenWiFi": 6,
    "DCPContentVersion": 7,
    "SRShow": 11                // 11: DCP 購買提醒 開關 1.On (default); 2.Off
}

const gLangTypeEnum = {
    "Major": 1,
    "Minor": 2
}

// DateTime 顯示的格式
const gDateTimeFormatEnum = {
  "DateOnly": 1,
  "TimeOnly": 2,
  "DateAndTime": 3,
  "DateAndTimeWithAmPm": 4,
  "TimeOnlyWithAmPm": 5,
  "MonthDay": 6,
  "Weekday": 7
}

// // 已不支援 舊版 Content  整理Code時要拿掉
// const gContentVerTypeEnum = {
//     // "Ver_2015": 1,
//     "Ver_Current": 99
// }

// // 已不支援 舊版 Content  整理Code時要拿掉
// // 支援新版的 BookCategoryID
// const gBookCategoryIDEnum = {
//     // "BC2015": 1,
//     "BCCurrent": 3
// }

const gButtonTypeEnum = {
    "Home": 0,
    "Lessons": 1,
    "Class": 2,
    "NoteList": 3,
    "Glossary": 4,
    "Settings": 5,
    "Help": 6,
    "Sync": 7,
    "LessonList": 8,
    "PDF": 9,
    "Assign": 10,
    "Note": 11,
    "Email": 12,
    "LearningUnit": 13,
    "Prelude": 14,
    "PreludeList": 15,
    "Resources": 16,
    "Assessment": 17,
    "BCApps": 18,
    
    "Test": 99
}

const gLUUserDataTypeEnum = {
    "SQCompAudio": 1,
    "SQCompImg1": 2,
    "SQCompImg2": 3,
    "SQCompImg3": 4,
    "CanDoAudio": 5,
    "PinyinIdentification": 100,
    "PinyinDictation": 101,
    "SQCQ": 102,    // Super Question包Choice Question
    "SQFQ": 103,    // Super Question包Fill In Question
    "SQCompText": 104
}

const gDataStatusFromAppEnum = {
    "MostUpdated": 1,
    "Cached": 2,
    "Cancel": 3
}

const gDataStatusFromAppIAPEnum = {
    "Success": 1,
    "Fail": 2,
    "Cancel": 3
}

const gResultCodeForAppInAppPurchaseSwiftUIEnum = {
    Successfully: 1,
    Cancel: 2,
    ErrorDefault: -99,
    ErrorProductIDFailed: -1,
    ErrorCMSWebServiceFailed: -2,
    ErrorNoReceiptFailed: -3,
    ErrorReceiptDataProcessedFailed: -4
}

// 老師或學生 執行考卷狀態
const gAssignReportStatusEnum = {
    "LUPractice": 0,    // LU練習
    "TeacherScore": 1,  // 老師評分
    "TeacherResult": 2, // 老師看考卷
    "StudentAnswer": 3, // 學生作答
    "StudentResult": 4  // 學生看考卷
}

// 滑鼠 事件點擊模式 
const gEventModeEnum = {
    "Mouse": 1,
    "Touch": 2
}

// 滑動方向
const gSwipeDirectionEnum = {
    "Left": 1,
    "Right": 2
}

const gChangeAnimationTypeEnum = {
    "None": 1,
    "Prev": 2,
    "Next": 3
}

// // 已不支援直式  整理Code時要拿掉
// const gOrientationModeEnum = {
//     "Landscape": 1,         // 橫式
//     "Portrait": 2           // 直式
// }

const gSettingsFuncIndexEnum = {
    "ProfileEdit": 0,
    "PasswordChang": 1,
    "SubscriptionUpdate": 2,
    "LangChange": 3,
    "ContentSwitch": 4
}

const gCSSIndexEnum = {
    "App": 1,
    "Prelude": 2,
    "ChromePreventVideoDownload": 3,
    "ChromePreventAudioDownload": 4,
    "ChromePreventVideoFullScreen": 5,
    "Edge": 6,
    "InAppiOS10AboveVideo": 7,
    "InAppiOSFontsTC": 8,
    "InAppiOSFontsSC": 9
}

// // 已不用App Sync機制  整理Code時要拿掉
// const gSyncEnum = {
//     "Syncing": 1,
//     "Finished": 2,
//     "Paused": 3,
//     "Failed": 4
// }

const gSRDifficultyEnum = {
    "Easy": 1,
    "Medium": 2,
    "Hard": 3
}

const gNewAssignmentStatusEnum = {
    "NotSubmitted": 1,
    "GradePending": 2,
    "NeedHelp": 3,
    "Completed": 4
}

// // 已經沒有支援 Auto辨識    整理Code時要拿掉
// // Read Aloud 給 App 用
// // Open SR 的時候
// // 目前只適用在 Siri Engine
// const gSRRecordModeEnum = {
//     "Auto": 1,
//     "Manual": 2
// }

const gDeviceType4DisplayEnum = {
    // iOS Device Type
    
    // iPhone
    "iPhone4_0": 1,         // 4.0" 5/5S/SE, 6/7/8 Zoom
    "iPhone4_7": 2,         // 4.7" 6/7/8 375x667   plus zoom
    "iPhone5_5": 3,         // 5.5" Plus 417x736
    "iPhoneX": 4,           // 5.8" 375x812 特殊處理    // iPhoneX, iPhoneXS
    // "iPhoneXR": 5,          // 5.8" 414x896 特殊處理   // iPhoneXR, iPhoneXS Max: richard 20190506 實驗結果，不會有 XR, 都變成 X
    "iPhoneNotSupported": 9,
        // iPad
    "iPad": 11,             // 768X1024
    // "iPadPro":12,           // 1024x1366  richard 20190506 實驗結果，不會有 iPad Pro, 都變成 iPad
    "iPadNotSupported": 19,

    "Android": 51,

    // Other
    "Other": 99
}

const gVideoTypeEnum = {
    "LessonAnimation": 1,
    "MagicVideo": 2,        // Characters 的 Magic Video (左下角第一個選單的影片)
    "Characters": 3         // Characters 字 的 影片
}

const gReminderTypeEnum = {
    "IOS12Upgrad": 1
}

const gLUChangePageStatusEnum = {
    "Next": 0,
    "Prev": 1,
    "Swipe": 2,
    "SectionMenuButton": 3,
    "SubSectionMenuButton": 4,
    "SubSubSectionMenuButton": 5
}

// const gEntranceTypeEnum =
// {
//     "Email4CreateAcc": 1,
//     "Forgot": 2,
//     "EmailSent": 3
// }

const gGlossaryBackStatusEnum = {
    "Nothing": 0,
    "GoToLU": 1
    // "OpenLogin": 2
}

const gDCPJsonEnum = {
    "BookCategory": 1,
    "Book": 2,
    "Homework": 3,
    "Lesson": 4
}

// 上下工具列狀態
const gToolbarStatusEnum = {
    "Home": 0,
    "Volume": 1,
    "LearningUnit": 2,
    "Prelude": 3
}

const gDCPLUEnum = {
    "LessonGoals": 1,
    "LessonAnimation": 2,
    "LessonIllustration": 3,
    "LessonLessonText": 4,
    "LanguageNotesVocabulary": 5,
    "LanguageNotesLanguagePoints": 6,
    "LanguageNotesLanguageTips": 7,
    "CulturePointsDiscoveringChina": 8,
    "CulturePointsChineseIdiom": 9,
    "PracticePinyinPronunciation": 10,
    "PracticePinyinIdentification": 11,
    "PracticePinyinDictation": 12,
    "PracticeCharacters": 17,
    "PracticeListening": 13,
    "PracticeFluency": 28,
    "PracticeSpeaking": 14,
    "PracticeReadingComprehension": 15,
    "PracticeReadingChallenge": 16,
    "PracticeWritingGrammarExercises": 26,
    "PracticeWritingComposition": 18,
    "PracticeActivity": 19,
    "ReviewListening": 20,
    "ReviewReading": 21,
    "ReviewWritingGrammarExercises": 27,
    "ReviewWritingComposition": 22,
    "ReviewSpeaking": 23,
    "CanDoStatements": 25                             // 題目參考 LessonGoals 的 Goals
}

const gAnsDataTypeEnum = {
    "SQCompAudio": 1,
    "SQCompImg1": 2,
    "SQCompImg2": 3,
    "SQCompImg3": 4,
    "CanDoAudio": 5,

    "PinyinIdentification": 100,
    "PinyinDictation": 101,
    "SQCQ": 102,
    "SQFQ": 103,
    "SQCompText": 104,

    "Characters": 110
}

const gQuestionTypeEnum = {
    "ChoiceQuestion": 2,
    "FillInQuestion": 3,
    "CompositionQuestion": 4,
    "PinyinIdentification": 5,
    "PinyinDictation": 6,
    "Fluency": 7
}

const gAuthorizedSubscriptionTypeEnum = {
    "Lesson": 1,
    "LessonMenu": 2,
    "Glossary": 3,
    "NoteList": 4,
    "Home": 5,
    "Resource": 6,
    "AssignReport": 7
}

// const gFileTypeEnum = {
//     "Image": 1,
//     "Audio": 2,
//     "Video": 3
// }
const gPracticeLUIndexEnum = {
    "PracticePinyinIdentification": 0,
    "PracticePinyinDictation": 1,
    "PracticeListening": 2,
    "PracticeFluency": 3,
    "PracticeSpeaking": 4,
    "PracticeReading": 5,
    "PracticeGrammarExercises": 6,
    "PracticeComposition": 7,
    "PracticeActivity": 8,
    "ReviewListening": 9,
    "ReviewReading": 10,
    "ReviewGrammarExercises": 11,
    "ReviewComposition": 12,
    "ReviewSpeaking": 13
}

const gLoginAfterStatusEnum = 
{
    "PCLWindow": 1,             // 親子條款視窗 Parent Consent Letter
    "Terms": 2,                 // 使用者條款視窗
    "AuthorizedCheck": 3,       // 授權到期提示視窗
    "SendVerify": 4,
    "VerifyEmail": 5,           // 驗證email提示視窗
    "VerifyEmailSuccess": 6,    // 驗證email成功視窗
    "End": 99
}

const gResourceTypeEnum =
{
    "Image": 1,
    "Audio": 2,
    "Video": 3
}

const gAudioStatusEnum = {
    "Stop": 0,
    "Playing": 1,
    "Paused": 2,
    "Loading": 3
}
// ========= Enum END =========

// SR 使用的評分標準
const garrGradeLevel = 
[
    // 注意
    // 0 分放第0個
    // 100 分放最後一個
    // 接著從低分的先放

    // 0, Empty
    {
        "ScoreUpperBound": 0.0,     // == 0
        "ScoreText":
        {
            "Major": "再试一次",
            "Minor": "再試一次"
        },
        // "SoundEffectFN": "try_again2.mp3"
        "SoundEffectFN": "Dummy.mp3"
    },
    // < 60, Under Pass
    {
        "ScoreUpperBound": 0.6,     // < 0.6
        "ScoreText":
        {
            "Major": "再试一次",
            "Minor": "再試一次"
        },
        // "SoundEffectFN": "try_again2.mp3"
        "SoundEffectFN": "Dummy.mp3"
    },
    // < 70, 
    {
        "ScoreUpperBound": 0.7,     // < 0.7
        "ScoreText":
        {
            "Major": "再试一次",
            "Minor": "再試一次"
        },
        // "SoundEffectFN": "try_again2.mp3"
        "SoundEffectFN": "Dummy.mp3"
    },
    // < 80, 
    {
        "ScoreUpperBound": 0.8,     // < 0.8
        "ScoreText":
        {
            "Major": "太棒了",
            "Minor": "太棒了"
        },
        "SoundEffectFN": "excellence.mp3"
    },
    // < 100, 
    {
        "ScoreUpperBound": 1.0,     // < 1.0
        "ScoreText":
        {
            "Major": "太棒了",
            "Minor": "太棒了"
        },
        "SoundEffectFN": "excellence.mp3"
    },
    // 100
    {
        "ScoreUpperBound": 1.0, // == 100
        "ScoreText":
        {
            "Major": "太棒了",
            "Minor": "太棒了"
        },
        "SoundEffectFN": "excellence.mp3"
    }

]

// 取得 是否 需要 全部作答 才能 Submit      Tim19.10.08
const garrLUAllAnswer = 
[
    {
        "LUSeqNo": gDCPLUEnum.PracticePinyinIdentification,      // 11
        "AllAnswer": true
    },
    {
        "LUSeqNo": gDCPLUEnum.PracticePinyinDictation,          // 12
        "AllAnswer": true
    },
    {
        "LUSeqNo": gDCPLUEnum.PracticeListening,                // 13
        "AllAnswer": true
    },
    {
        "LUSeqNo": gDCPLUEnum.PracticeFluency,                  // 28
        "AllAnswer": true
    },
    {
        "LUSeqNo": gDCPLUEnum.PracticeSpeaking,                 // 14
        "AllAnswer": false
    },
    {
        "LUSeqNo": gDCPLUEnum.PracticeReadingComprehension,     // 15
        "AllAnswer": true
    },
    {
        "LUSeqNo": gDCPLUEnum.PracticeWritingGrammarExercises,  // 26
        "AllAnswer": false
    },
    {
        "LUSeqNo": gDCPLUEnum.PracticeWritingComposition,       // 18
        "AllAnswer": false
    },
    {
        "LUSeqNo": gDCPLUEnum.PracticeActivity,                 // 19
        "AllAnswer": false
    },
    {
        "LUSeqNo": gDCPLUEnum.ReviewListening,                // 20
        "AllAnswer": true
    },
    {
        "LUSeqNo": gDCPLUEnum.ReviewReading,                  // 21
        "AllAnswer": true
    },
    {
        "LUSeqNo": gDCPLUEnum.ReviewWritingGrammarExercises,  // 27
        "AllAnswer": false
    },
    {
        "LUSeqNo": gDCPLUEnum.ReviewWritingComposition,       // 22
        "AllAnswer": false
    },
    {
        "LUSeqNo": gDCPLUEnum.ReviewSpeaking,                 // 23
        "AllAnswer": false
    }
]

const garrPracticeLU = [
    // {
    //     "Section": "Practice",
    //     "SubSection": "Pinyin",
    //     "SubSubSection": "Pronunciation",
    //     "LUSeqNo": 10
    // },
    {
        "Section": "Practice",
        "SubSection": "Pinyin",
        "SubSubSection": "Identfication",
        "DisplayName": "Practice Pinyin Identification",
        "Abbreviation":  "PI",
        "LUCatSeqNo": 11,
        "NewAssignmentType": 1,
        "AssigmentName": "Practice Pinyin - Pinyin Identification"
    },
    {
        "Section": "Practice",
        "SubSection": "Pinyin",
        "SubSubSection": "Dictation",
        "DisplayName": "Practice Pinyin Dictation",
        "Abbreviation":  "PD",
        "LUCatSeqNo": 12,
        "NewAssignmentType": 2,
        "AssigmentName": "Practice Pinyin - Pinyin Dictation"
    },
    // {
    //     "Section": "Practice",
    //     "SubSection": "Characters",
    //     "SubSubSection": null,
    //     "LUCatSeqNo": 17
    // },
    {
        "Section": "Practice",
        "SubSection": "Listening",
        "SubSubSection": null,
        "DisplayName": "Practice Listening",
        "Abbreviation":  "L",
        "LUCatSeqNo": 13,
        "NewAssignmentType": 3,
        "AssigmentName": "Practice Listening"
    },
    {
        "Section": "Practice",
        "SubSection": "Fluency",
        "SubSubSection": null,
        "DisplayName": "Practice Fluency",
        "Abbreviation":  "F",
        "LUCatSeqNo": 28,
        "NewAssignmentType": 14,
        "AssigmentName": "Practice Fluency"
    },
    {
        "Section": "Practice",
        "SubSection": "Speaking",
        "SubSubSection": null,
        "DisplayName": "Practice Speaking",
        "Abbreviation":  "S",
        "LUCatSeqNo": 14,
        "NewAssignmentType": 4,
        "AssigmentName": "Practice Speaking"
    },
    {
        "Section": "Practice",
        "SubSection": "Reading",
        "SubSubSection": "Comprehension",
        "DisplayName": "Practice Reading",
        "Abbreviation":  "R",
        "LUCatSeqNo": 15,
        "NewAssignmentType": 5,
        "AssigmentName": "Practice Reading - Comprehension"
    },
    {
        "Section": "Practice",
        "SubSection": "Writing",
        "SubSubSection": "Grammar Exercises",
        "DisplayName": "Practice Grammar Exercises",
        "Abbreviation":  "G",
        "LUCatSeqNo": 26,
        "NewAssignmentType": 6,
        "AssigmentName": "Practice Writing - Grammar Exercises"
    },
    {
        "Section": "Practice",
        "SubSection": "Writing",
        "SubSubSection": "Composition",
        "DisplayName": "Practice Composition",
        "Abbreviation":  "C",
        "LUCatSeqNo": 18,
        "NewAssignmentType": 7,
        "AssigmentName": "Practice Writing - Composition"
    },
    {
        "Section": "Practice",
        "SubSection": "Activity",
        "SubSubSection": null,
        "DisplayName": "Practice Activity",
        "Abbreviation":  "A",
        "LUCatSeqNo": 19,
        "NewAssignmentType": 8,
        "AssigmentName": "Practice Activity"
    },
    {
        "Section": "Review",
        "SubSection": "Listening",
        "SubSubSection": null,
        "DisplayName": "Review Listening",
        "Abbreviation":  "L",
        "LUCatSeqNo": 20,
        "NewAssignmentType": 9,
        "AssigmentName": "Review Listening"
    },
    {
        "Section": "Review",
        "SubSection": "Reading",
        "SubSubSection": null,
        "DisplayName": "Review Reading",
        "Abbreviation":  "R",
        "LUCatSeqNo": 21,
        "NewAssignmentType": 10,
        "AssigmentName": "Review Reading"
    },    
    {
        "Section": "Review",
        "SubSection": "Writing",
        "SubSubSection": "Grammar Exercises",
        "DisplayName": "Review Grammar Exercises",
        "Abbreviation":  "G",
        "LUCatSeqNo": 27,
        "NewAssignmentType": 11,
        "AssigmentName": "Review Writing - Grammar Exercises"
    },
    {
        "Section": "Review",
        "SubSection": "Writing",
        "SubSubSection": "Composition",
        "DisplayName": "Review Composition",
        "Abbreviation":  "C",
        "LUCatSeqNo": 22,
        "NewAssignmentType": 12,
        "AssigmentName": "Review Writing - Composition"
    },
    {
        "Section": "Review",
        "SubSection": "Speaking",
        "SubSubSection": null,
        "DisplayName": "Review Speaking",
        "Abbreviation":  "S",
        "LUCatSeqNo": 23,
        "NewAssignmentType": 13,
        "AssigmentName": "Review Speaking"
    }
]

const garrDCPLUSwipeSeq = [
    gDCPLUEnum.LessonGoals,                        // 1
    gDCPLUEnum.LessonAnimation,                    // 2
    gDCPLUEnum.LessonIllustration,                 // 3
    gDCPLUEnum.LessonLessonText,                   // 4,
    gDCPLUEnum.LanguageNotesVocabulary,            // 5,
    gDCPLUEnum.LanguageNotesLanguagePoints,        // 6,
    gDCPLUEnum.LanguageNotesLanguageTips,          // 7,
    gDCPLUEnum.CulturePointsDiscoveringChina,      // 8,
    gDCPLUEnum.CulturePointsChineseIdiom,          // 9,
    gDCPLUEnum.PracticePinyinPronunciation,       // 10,
    gDCPLUEnum.PracticePinyinIdentification,       // 11,
    gDCPLUEnum.PracticePinyinDictation,           // 12,
    gDCPLUEnum.PracticeCharacters,                 // 17,
    gDCPLUEnum.PracticeListening,                  // 13,
    gDCPLUEnum.PracticeFluency,                     // 28,
    gDCPLUEnum.PracticeSpeaking,                   // 14,
    gDCPLUEnum.PracticeReadingComprehension,      // 15,
    gDCPLUEnum.PracticeReadingChallenge,          // 16,
    gDCPLUEnum.PracticeWritingGrammarExercises,  // 26,
    gDCPLUEnum.PracticeWritingComposition,        // 18,
    gDCPLUEnum.PracticeActivity,                   // 19,
    gDCPLUEnum.ReviewListening,                  // 20,
    gDCPLUEnum.ReviewReading,                    // 21,
    gDCPLUEnum.ReviewWritingGrammarExercises,  // 27,
    gDCPLUEnum.ReviewWritingComposition,        // 22,
    gDCPLUEnum.ReviewSpeaking,                   // 23,
    gDCPLUEnum.CanDoStatements                                // 25 
]

// 國家
const garrCountry = [{"ID": 1,"BackendID": "USA"},{"ID": 2,"BackendID": "Armenia"},{"ID": 3,"BackendID": "Australia"},{"ID": 4,"BackendID": "Austria"},{"ID": 5,"BackendID": "Belarus"},{"ID": 6,"BackendID": "Belgium"},{"ID": 7,"BackendID": "Brazil"},{"ID": 8,"BackendID": "Bulgaria"},{"ID": 9,"BackendID": "Canada"},{"ID": 10,"BackendID": "Chile"},{"ID": 11,"BackendID": "China"},{"ID": 12,"BackendID": "Colombia"},{"ID": 13,"BackendID": "Columbia"},{"ID": 14,"BackendID": "Costa Rica"},{"ID": 15,"BackendID": "Croatia"},{"ID": 16,"BackendID": "Cyprus"},{"ID": 17,"BackendID": "Czech Republic"},{"ID": 18,"BackendID": "Denmark"},{"ID": 19,"BackendID": "Dominican Republic"},{"ID": 20,"BackendID": "Egypt"},{"ID": 21,"BackendID": "England"},{"ID": 22,"BackendID": "Estonia"},{"ID": 23,"BackendID": "Finland"},{"ID": 24,"BackendID": "France"},{"ID": 25,"BackendID": "French Polynesia"},{"ID": 26,"BackendID": "Germany"},{"ID": 27,"BackendID": "Ghana"},{"ID": 28,"BackendID": "Greece"},{"ID": 29,"BackendID": "Guatemala"},{"ID": 30,"BackendID": "Hong Kong"},{"ID": 31,"BackendID": "Hungary"},{"ID": 32,"BackendID": "India"},{"ID": 33,"BackendID": "Indonesia"},{"ID": 34,"BackendID": "Ireland"},{"ID": 35,"BackendID": "Israel"},{"ID": 36,"BackendID": "Italy"},{"ID": 37,"BackendID": "Japan"},{"ID": 38,"BackendID": "Korea"},{"ID": 39,"BackendID": "Latvia"},{"ID": 40,"BackendID": "Lithuania"},{"ID": 41,"BackendID": "Malaysia"},{"ID": 42,"BackendID": "Melbourne"},{"ID": 43,"BackendID": "Mexico"},{"ID": 44,"BackendID": "Morocco"},{"ID": 45,"BackendID": "Netherlands"},{"ID": 46,"BackendID": "New Zealand"},{"ID": 47,"BackendID": "Norway"},{"ID": 48,"BackendID": "Panama"},{"ID": 49,"BackendID": "Paraguay"},{"ID": 50,"BackendID": "Peru"},{"ID": 51,"BackendID": "Philippines"},{"ID": 52,"BackendID": "Poland"},{"ID": 53,"BackendID": "Portugal"},{"ID": 54,"BackendID": "Puerto Rico"},{"ID": 55,"BackendID": "Romania"},{"ID": 56,"BackendID": "Russia"},{"ID": 57,"BackendID": "Senegal"},{"ID": 58,"BackendID": "Singapore"},{"ID": 59,"BackendID": "South Africa"},{"ID": 60,"BackendID": "Spain"},{"ID": 61,"BackendID": "Sweden"},{"ID": 62,"BackendID": "Switzerland"},{"ID": 63,"BackendID": "Taiwan"},{"ID": 64,"BackendID": "Thailand"},{"ID": 65,"BackendID": "Trinidad and Tobago"},{"ID": 66,"BackendID": "Turkey"},{"ID": 67,"BackendID": "Uganda"},{"ID": 68,"BackendID": "United Kingdom"},{"ID": 69,"BackendID": "Virgin Islands"}]

// // 時差
// const garrTimeZone = [{"ID": 1,"Value": "-12:00"},{"ID": 2,"Value": "-11:00"},{"ID": 3,"Value": "-10:00"},{"ID": 4,"Value": "-09:30"},{"ID": 5,"Value": "-09:00"},{"ID": 6,"Value": "-08:00"},{"ID": 7,"Value": "-07:00"},{"ID": 8,"Value": "-06:00"},{"ID": 9,"Value": "-05:00"},{"ID": 10,"Value": "-04:30"},{"ID": 11,"Value": "-04:00"},{"ID": 12,"Value": "-03:30"},{"ID": 13,"Value": "-03:00"},{"ID": 14,"Value": "-02:00"},{"ID": 15,"Value": "-01:00"},{"ID": 16,"Value": "+00:00"},{"ID": 17,"Value": "+01:00"},{"ID": 18,"Value": "+02:00"},{"ID": 19,"Value": "+03:00"},{"ID": 20,"Value": "+03:30"},{"ID": 21,"Value": "+04:00"},{"ID": 22,"Value": "+04:30"},{"ID": 23,"Value": "+05:00"},{"ID": 24,"Value": "+05:30"},{"ID": 25,"Value": "+05:45"},{"ID": 26,"Value": "+06:00"},{"ID": 27,"Value": "+06:30"},{"ID": 28,"Value": "+07:00"},{"ID": 29,"Value": "+08:00"},{"ID": 30,"Value": "+08:45"},{"ID": 31,"Value": "+09:00"},{"ID": 32,"Value": "+09:30"},{"ID": 33,"Value": "+10:00"},{"ID": 34,"Value": "+10:30"},{"ID": 35,"Value": "+11:00"},{"ID": 36,"Value": "+11:30"},{"ID": 37,"Value": "+12:00"},{"ID": 38,"Value": "+12:45"},{"ID": 39,"Value": "+13:00"},{"ID": 40,"Value": "+14:00"}]

// var garrCharacters = [
//     {"Volume": 1,"Lesson": 1,"Major": "你","Minor": "你"},{"Volume": 1,"Lesson": 1,"Major": "好","Minor": "好"},{"Volume": 1,"Lesson": 1,"Major": "再","Minor": "再"},{"Volume": 1,"Lesson": 1,"Major": "见","Minor": "見"},{"Volume": 1,"Lesson": 1,"Major": "同","Minor": "同"},{"Volume": 1,"Lesson": 1,"Major": "学","Minor": "學"},{"Volume": 1,"Lesson": 1,"Major": "们","Minor": "們"},{"Volume": 1,"Lesson": 1,"Major": "老","Minor": "老"},{"Volume": 1,"Lesson": 1,"Major": "师","Minor": "師"},{"Volume": 1,"Lesson": 1,"Major": "吗","Minor": "嗎"},{"Volume": 1,"Lesson": 1,"Major": "我","Minor": "我"},{"Volume": 1,"Lesson": 1,"Major": "很","Minor": "很"},{"Volume": 1,"Lesson": 1,"Major": "谢","Minor": "謝"},
//   {
//     "Volume": 1,
//     "Lesson": 2,
//     "Major": "叫",
//     "Minor": "叫"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 2,
//     "Major": "什",
//     "Minor": "什"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 2,
//     "Major": "么",
//     "Minor": "麽"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 2,
//     "Major": "名",
//     "Minor": "名"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 2,
//     "Major": "字",
//     "Minor": "字"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 2,
//     "Major": "他",
//     "Minor": "他"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 2,
//     "Major": "姓",
//     "Minor": "姓"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 2,
//     "Major": "她",
//     "Minor": "她"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 2,
//     "Major": "王",
//     "Minor": "王"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 2,
//     "Major": "李",
//     "Minor": "李"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 2,
//     "Major": "白",
//     "Minor": "白"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 2,
//     "Major": "林",
//     "Minor": "林"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 3,
//     "Major": "多",
//     "Minor": "多"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 3,
//     "Major": "大",
//     "Minor": "大"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 3,
//     "Major": "岁",
//     "Minor": "歲"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 3,
//     "Major": "呢",
//     "Minor": "呢"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 3,
//     "Major": "也",
//     "Minor": "也"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 3,
//     "Major": "零",
//     "Minor": "零"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 3,
//     "Major": "百",
//     "Minor": "百"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 3,
//     "Major": "千",
//     "Minor": "千"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 3,
//     "Major": "小",
//     "Minor": "小"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 4,
//     "Major": "是",
//     "Minor": "是"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 4,
//     "Major": "哪",
//     "Minor": "哪"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 4,
//     "Major": "国",
//     "Minor": "國"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 4,
//     "Major": "人",
//     "Minor": "人"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 4,
//     "Major": "中",
//     "Minor": "中"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 4,
//     "Major": "美",
//     "Minor": "美"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 4,
//     "Major": "不",
//     "Minor": "不"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 4,
//     "Major": "英",
//     "Minor": "英"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 5,
//     "Major": "上",
//     "Minor": "上"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 5,
//     "Major": "个",
//     "Minor": "個"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 5,
//     "Major": "校",
//     "Minor": "校"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 5,
//     "Major": "初",
//     "Minor": "初"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 5,
//     "Major": "高",
//     "Minor": "高"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 5,
//     "Major": "几",
//     "Minor": "幾"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 5,
//     "Major": "年",
//     "Minor": "年"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 5,
//     "Major": "级",
//     "Minor": "級"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 6,
//     "Major": "家",
//     "Minor": "家"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 6,
//     "Major": "没",
//     "Minor": "沒"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 6,
//     "Major": "有",
//     "Minor": "有"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 6,
//     "Major": "爸",
//     "Minor": "爸"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 6,
//     "Major": "妈",
//     "Minor": "媽"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 6,
//     "Major": "哥",
//     "Minor": "哥"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 6,
//     "Major": "姐",
//     "Minor": "姐"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 6,
//     "Major": "弟",
//     "Minor": "弟"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 6,
//     "Major": "和",
//     "Minor": "和"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 6,
//     "Major": "这",
//     "Minor": "這"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 6,
//     "Major": "的",
//     "Minor": "的"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 6,
//     "Major": "谁",
//     "Minor": "誰"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 6,
//     "Major": "妹",
//     "Minor": "妹"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 7,
//     "Major": "住",
//     "Minor": "住"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 7,
//     "Major": "在",
//     "Minor": "在"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 7,
//     "Major": "儿",
//     "Minor": "兒"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 7,
//     "Major": "街",
//     "Minor": "街"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 7,
//     "Major": "号",
//     "Minor": "號"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 7,
//     "Major": "路",
//     "Minor": "路"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 7,
//     "Major": "楼",
//     "Minor": "樓"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 7,
//     "Major": "都",
//     "Minor": "都"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 7,
//     "Major": "公",
//     "Minor": "公"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 7,
//     "Major": "园",
//     "Minor": "園"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 8,
//     "Major": "昨",
//     "Minor": "昨"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 8,
//     "Major": "天",
//     "Minor": "天"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 8,
//     "Major": "今",
//     "Minor": "今"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 8,
//     "Major": "星",
//     "Minor": "星"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 8,
//     "Major": "期",
//     "Minor": "期"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 8,
//     "Major": "明",
//     "Minor": "明"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 8,
//     "Major": "月",
//     "Minor": "月"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 8,
//     "Major": "日",
//     "Minor": "日"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 8,
//     "Major": "祝",
//     "Minor": "祝"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 8,
//     "Major": "生",
//     "Minor": "生"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 9,
//     "Major": "书",
//     "Minor": "書"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 9,
//     "Major": "包",
//     "Minor": "包"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 9,
//     "Major": "里",
//     "Minor": "裡"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 9,
//     "Major": "前",
//     "Minor": "前"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 9,
//     "Major": "面",
//     "Minor": "面"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 9,
//     "Major": "手",
//     "Minor": "手"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 9,
//     "Major": "电",
//     "Minor": "電"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 9,
//     "Major": "那",
//     "Minor": "那"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 9,
//     "Major": "桌",
//     "Minor": "桌"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 9,
//     "Major": "椅",
//     "Minor": "椅"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 9,
//     "Major": "后",
//     "Minor": "後"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 9,
//     "Major": "下",
//     "Minor": "下"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 10,
//     "Major": "最",
//     "Minor": "最"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 10,
//     "Major": "喜",
//     "Minor": "喜"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 10,
//     "Major": "欢",
//     "Minor": "歡"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 10,
//     "Major": "吃",
//     "Minor": "吃"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 10,
//     "Major": "水",
//     "Minor": "水"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 10,
//     "Major": "果",
//     "Minor": "果"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 10,
//     "Major": "香",
//     "Minor": "香"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 10,
//     "Major": "蕉",
//     "Minor": "蕉"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 10,
//     "Major": "苹",
//     "Minor": "蘋"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 10,
//     "Major": "橙",
//     "Minor": "橙"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 10,
//     "Major": "瓜",
//     "Minor": "瓜"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 11,
//     "Major": "饿",
//     "Minor": "餓"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 11,
//     "Major": "了",
//     "Minor": "了"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 11,
//     "Major": "想",
//     "Minor": "想"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 11,
//     "Major": "汉",
//     "Minor": "漢"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 11,
//     "Major": "吧",
//     "Minor": "吧"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 11,
//     "Major": "渴",
//     "Minor": "渴"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 11,
//     "Major": "喝",
//     "Minor": "喝"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 11,
//     "Major": "东",
//     "Minor": "東"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 11,
//     "Major": "西",
//     "Minor": "西"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 11,
//     "Major": "汽",
//     "Minor": "汽"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 12,
//     "Major": "去",
//     "Minor": "去"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 12,
//     "Major": "饭",
//     "Minor": "飯"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 12,
//     "Major": "餐",
//     "Minor": "餐"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 12,
//     "Major": "饺",
//     "Minor": "餃"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 12,
//     "Major": "太",
//     "Minor": "太"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 12,
//     "Major": "碗",
//     "Minor": "碗"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 12,
//     "Major": "汤",
//     "Minor": "湯"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 12,
//     "Major": "真",
//     "Minor": "真"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 12,
//     "Major": "来",
//     "Minor": "來"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 12,
//     "Major": "米",
//     "Minor": "米"
//   },
//   {
//     "Volume": 1,
//     "Lesson": 12,
//     "Major": "条",
//     "Minor": "條"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 13,
//     "Major": "颜",
//     "Minor": "顏"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 13,
//     "Major": "色",
//     "Minor": "色"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 13,
//     "Major": "蓝",
//     "Minor": "藍"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 13,
//     "Major": "黑",
//     "Minor": "黑"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 13,
//     "Major": "或",
//     "Minor": "或"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 13,
//     "Major": "者",
//     "Minor": "者"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 13,
//     "Major": "买",
//     "Minor": "買"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 13,
//     "Major": "些",
//     "Minor": "些"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 13,
//     "Major": "黄",
//     "Minor": "黃"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 13,
//     "Major": "红",
//     "Minor": "紅"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 13,
//     "Major": "绿",
//     "Minor": "綠"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 13,
//     "Major": "紫",
//     "Minor": "紫"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 14,
//     "Major": "新",
//     "Minor": "新"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 14,
//     "Major": "穿",
//     "Minor": "穿"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 14,
//     "Major": "衣",
//     "Minor": "衣"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 14,
//     "Major": "服",
//     "Minor": "服"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 14,
//     "Major": "衬",
//     "Minor": "襯"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 14,
//     "Major": "衫",
//     "Minor": "衫"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 14,
//     "Major": "对",
//     "Minor": "對"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 14,
//     "Major": "件",
//     "Minor": "件"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 14,
//     "Major": "裤",
//     "Minor": "褲"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 14,
//     "Major": "但",
//     "Minor": "但"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 14,
//     "Major": "双",
//     "Minor": "雙"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 14,
//     "Major": "裙",
//     "Minor": "裙"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 15,
//     "Major": "朋",
//     "Minor": "朋"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 15,
//     "Major": "友",
//     "Minor": "友"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 15,
//     "Major": "女",
//     "Minor": "女"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 15,
//     "Major": "矮",
//     "Minor": "矮"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 15,
//     "Major": "眼",
//     "Minor": "眼"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 15,
//     "Major": "睛",
//     "Minor": "睛"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 15,
//     "Major": "鼻",
//     "Minor": "鼻"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 15,
//     "Major": "嘴",
//     "Minor": "嘴"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 15,
//     "Major": "耳",
//     "Minor": "耳"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 15,
//     "Major": "男",
//     "Minor": "男"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 15,
//     "Major": "短",
//     "Minor": "短"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 16,
//     "Major": "运",
//     "Minor": "運"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 16,
//     "Major": "动",
//     "Minor": "動"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 16,
//     "Major": "跑",
//     "Minor": "跑"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 16,
//     "Major": "踢",
//     "Minor": "踢"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 16,
//     "Major": "足",
//     "Minor": "足"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 16,
//     "Major": "球",
//     "Minor": "球"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 16,
//     "Major": "打",
//     "Minor": "打"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 16,
//     "Major": "篮",
//     "Minor": "籃"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 16,
//     "Major": "游",
//     "Minor": "游"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 16,
//     "Major": "会",
//     "Minor": "會"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 16,
//     "Major": "网",
//     "Minor": "網"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 16,
//     "Major": "棒",
//     "Minor": "棒"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 16,
//     "Major": "看",
//     "Minor": "看"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 16,
//     "Major": "教",
//     "Minor": "教"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 17,
//     "Major": "养",
//     "Minor": "養"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 17,
//     "Major": "鸟",
//     "Minor": "鳥"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 17,
//     "Major": "它",
//     "Minor": "牠"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 17,
//     "Major": "说",
//     "Minor": "說"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 17,
//     "Major": "话",
//     "Minor": "話"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 17,
//     "Major": "金",
//     "Minor": "金"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 17,
//     "Major": "鱼",
//     "Minor": "魚"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 17,
//     "Major": "只",
//     "Minor": "隻"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 17,
//     "Major": "猫",
//     "Minor": "貓"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 17,
//     "Major": "狗",
//     "Minor": "狗"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 17,
//     "Major": "因",
//     "Minor": "因"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 17,
//     "Major": "为",
//     "Minor": "為"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 18,
//     "Major": "语",
//     "Minor": "語"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 18,
//     "Major": "言",
//     "Minor": "言"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 18,
//     "Major": "德",
//     "Minor": "德"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 18,
//     "Major": "法",
//     "Minor": "法"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 18,
//     "Major": "文",
//     "Minor": "文"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 18,
//     "Major": "用",
//     "Minor": "用"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 18,
//     "Major": "写",
//     "Minor": "寫"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 18,
//     "Major": "作",
//     "Minor": "作"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 18,
//     "Major": "点",
//     "Minor": "點"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 18,
//     "Major": "如",
//     "Minor": "如"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 18,
//     "Major": "暑",
//     "Minor": "暑"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 18,
//     "Major": "假",
//     "Minor": "假"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 18,
//     "Major": "习",
//     "Minor": "習"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 18,
//     "Major": "听",
//     "Minor": "聽"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 19,
//     "Major": "要",
//     "Minor": "要"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 19,
//     "Major": "迎",
//     "Minor": "迎"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 19,
//     "Major": "钱",
//     "Minor": "錢"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 19,
//     "Major": "块",
//     "Minor": "塊"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 19,
//     "Major": "贵",
//     "Minor": "貴"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 19,
//     "Major": "可",
//     "Minor": "可"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 19,
//     "Major": "以",
//     "Minor": "以"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 19,
//     "Major": "起",
//     "Minor": "起"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 19,
//     "Major": "能",
//     "Minor": "能"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 19,
//     "Major": "还",
//     "Minor": "還"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 19,
//     "Major": "价",
//     "Minor": "價"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 19,
//     "Major": "找",
//     "Minor": "找"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 20,
//     "Major": "早",
//     "Minor": "早"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 20,
//     "Major": "床",
//     "Minor": "床"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 20,
//     "Major": "半",
//     "Minor": "半"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 20,
//     "Major": "周",
//     "Minor": "週"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 20,
//     "Major": "末",
//     "Minor": "末"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 20,
//     "Major": "晚",
//     "Minor": "晚"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 20,
//     "Major": "分",
//     "Minor": "分"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 20,
//     "Major": "放",
//     "Minor": "放"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 20,
//     "Major": "回",
//     "Minor": "回"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 20,
//     "Major": "午",
//     "Minor": "午"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 20,
//     "Major": "做",
//     "Minor": "做"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 20,
//     "Major": "业",
//     "Minor": "業"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 20,
//     "Major": "课",
//     "Minor": "課"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 20,
//     "Major": "时",
//     "Minor": "時"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 21,
//     "Major": "视",
//     "Minor": "視"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 21,
//     "Major": "剧",
//     "Minor": "劇"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 21,
//     "Major": "讲",
//     "Minor": "講"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 21,
//     "Major": "戏",
//     "Minor": "戲"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 21,
//     "Major": "阳",
//     "Minor": "陽"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 21,
//     "Major": "休",
//     "Minor": "休"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 21,
//     "Major": "息",
//     "Minor": "息"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 21,
//     "Major": "重",
//     "Minor": "重"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 21,
//     "Major": "考",
//     "Minor": "考"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 21,
//     "Major": "试",
//     "Minor": "試"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 22,
//     "Major": "气",
//     "Minor": "氣"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 22,
//     "Major": "怎",
//     "Minor": "怎"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 22,
//     "Major": "样",
//     "Minor": "樣"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 22,
//     "Major": "阴",
//     "Minor": "陰"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 22,
//     "Major": "冷",
//     "Minor": "冷"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 22,
//     "Major": "雨",
//     "Minor": "雨"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 22,
//     "Major": "刮",
//     "Minor": "颳"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 22,
//     "Major": "风",
//     "Minor": "風"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 22,
//     "Major": "温",
//     "Minor": "溫"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 22,
//     "Major": "越",
//     "Minor": "越"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 22,
//     "Major": "低",
//     "Minor": "低"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 22,
//     "Major": "雪",
//     "Minor": "雪"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 22,
//     "Major": "晴",
//     "Minor": "晴"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 22,
//     "Major": "暖",
//     "Minor": "暖"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 22,
//     "Major": "热",
//     "Minor": "熱"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 23,
//     "Major": "影",
//     "Minor": "影"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 23,
//     "Major": "直",
//     "Minor": "直"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 23,
//     "Major": "往",
//     "Minor": "往"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 23,
//     "Major": "到",
//     "Minor": "到"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 23,
//     "Major": "向",
//     "Minor": "向"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 23,
//     "Major": "左",
//     "Minor": "左"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 23,
//     "Major": "远",
//     "Minor": "遠"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 23,
//     "Major": "知",
//     "Minor": "知"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 23,
//     "Major": "道",
//     "Minor": "道"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 23,
//     "Major": "南",
//     "Minor": "南"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 23,
//     "Major": "从",
//     "Minor": "從"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 23,
//     "Major": "第",
//     "Minor": "第"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 23,
//     "Major": "右",
//     "Minor": "右"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 23,
//     "Major": "北",
//     "Minor": "北"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 24,
//     "Major": "先",
//     "Minor": "先"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 24,
//     "Major": "坐",
//     "Minor": "坐"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 24,
//     "Major": "飞",
//     "Minor": "飛"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 24,
//     "Major": "机",
//     "Minor": "機"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 24,
//     "Major": "火",
//     "Minor": "火"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 24,
//     "Major": "车",
//     "Minor": "車"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 24,
//     "Major": "又",
//     "Minor": "又"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 24,
//     "Major": "快",
//     "Minor": "快"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 24,
//     "Major": "开",
//     "Minor": "開"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 24,
//     "Major": "接",
//     "Minor": "接"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 24,
//     "Major": "带",
//     "Minor": "帶"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 24,
//     "Major": "极",
//     "Minor": "極"
//   },
//   {
//     "Volume": 2,
//     "Lesson": 24,
//     "Major": "茶",
//     "Minor": "茶"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 25,
//     "Major": "过",
//     "Minor": "過"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 25,
//     "Major": "得",
//     "Minor": "得"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 25,
//     "Major": "转",
//     "Minor": "轉"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 25,
//     "Major": "选",
//     "Minor": "選"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 25,
//     "Major": "班",
//     "Minor": "班"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 25,
//     "Major": "跟",
//     "Minor": "跟"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 25,
//     "Major": "爷",
//     "Minor": "爺"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 25,
//     "Major": "奶",
//     "Minor": "奶"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 25,
//     "Major": "练",
//     "Minor": "練"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 25,
//     "Major": "相",
//     "Minor": "相"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 26,
//     "Major": "程",
//     "Minor": "程"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 26,
//     "Major": "表",
//     "Minor": "表"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 26,
//     "Major": "排",
//     "Minor": "排"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 26,
//     "Major": "除",
//     "Minor": "除"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 26,
//     "Major": "数",
//     "Minor": "數"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 26,
//     "Major": "历",
//     "Minor": "歷"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 26,
//     "Major": "史",
//     "Minor": "史"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 26,
//     "Major": "化",
//     "Minor": "化"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 26,
//     "Major": "物",
//     "Minor": "物"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 26,
//     "Major": "理",
//     "Minor": "理"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 26,
//     "Major": "门",
//     "Minor": "門"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 26,
//     "Major": "艺",
//     "Minor": "藝"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 26,
//     "Major": "难",
//     "Minor": "難"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 26,
//     "Major": "心",
//     "Minor": "心"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 27,
//     "Major": "别",
//     "Minor": "別"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 27,
//     "Major": "忘",
//     "Minor": "忘"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 27,
//     "Major": "把",
//     "Minor": "把"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 27,
//     "Major": "关",
//     "Minor": "關"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 27,
//     "Major": "掉",
//     "Minor": "掉"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 27,
//     "Major": "计",
//     "Minor": "計"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 27,
//     "Major": "花",
//     "Minor": "花"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 27,
//     "Major": "完",
//     "Minor": "完"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 27,
//     "Major": "组",
//     "Minor": "組"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 27,
//     "Major": "题",
//     "Minor": "題"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 27,
//     "Major": "觉",
//     "Minor": "覺"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 27,
//     "Major": "认",
//     "Minor": "認"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 27,
//     "Major": "准",
//     "Minor": "準"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 28,
//     "Major": "广",
//     "Minor": "廣"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 28,
//     "Major": "告",
//     "Minor": "告"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 28,
//     "Major": "司",
//     "Minor": "司"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 28,
//     "Major": "工",
//     "Minor": "工"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 28,
//     "Major": "像",
//     "Minor": "像"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 28,
//     "Major": "医",
//     "Minor": "醫"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 28,
//     "Major": "已",
//     "Minor": "已"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 28,
//     "Major": "经",
//     "Minor": "經"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 28,
//     "Major": "退",
//     "Minor": "退"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 28,
//     "Major": "候",
//     "Minor": "候"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 28,
//     "Major": "店",
//     "Minor": "店"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 28,
//     "Major": "科",
//     "Minor": "科"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 28,
//     "Major": "技",
//     "Minor": "技"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 28,
//     "Major": "将",
//     "Minor": "將"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 29,
//     "Major": "讨",
//     "Minor": "討"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 29,
//     "Major": "论",
//     "Minor": "論"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 29,
//     "Major": "兴",
//     "Minor": "興"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 29,
//     "Major": "趣",
//     "Minor": "趣"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 29,
//     "Major": "音",
//     "Minor": "音"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 29,
//     "Major": "乐",
//     "Minor": "樂"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 29,
//     "Major": "唱",
//     "Minor": "唱"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 29,
//     "Major": "歌",
//     "Minor": "歌"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 29,
//     "Major": "弹",
//     "Minor": "彈"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 29,
//     "Major": "琴",
//     "Minor": "琴"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 29,
//     "Major": "画",
//     "Minor": "畫"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 29,
//     "Major": "参",
//     "Minor": "參"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 29,
//     "Major": "加",
//     "Minor": "加"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 29,
//     "Major": "队",
//     "Minor": "隊"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 30,
//     "Major": "记",
//     "Minor": "記"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 30,
//     "Major": "获",
//     "Minor": "獲"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 30,
//     "Major": "惜",
//     "Minor": "惜"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 30,
//     "Major": "病",
//     "Minor": "病"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 30,
//     "Major": "而",
//     "Minor": "而"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 30,
//     "Major": "且",
//     "Minor": "且"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 30,
//     "Major": "跳",
//     "Minor": "跳"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 30,
//     "Major": "差",
//     "Minor": "差"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 30,
//     "Major": "满",
//     "Minor": "滿"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 30,
//     "Major": "意",
//     "Minor": "意"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 30,
//     "Major": "成",
//     "Minor": "成"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 30,
//     "Major": "就",
//     "Minor": "就"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 31,
//     "Major": "房",
//     "Minor": "房"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 31,
//     "Major": "间",
//     "Minor": "間"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 31,
//     "Major": "介",
//     "Minor": "介"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 31,
//     "Major": "绍",
//     "Minor": "紹"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 31,
//     "Major": "层",
//     "Minor": "層"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 31,
//     "Major": "厅",
//     "Minor": "廳"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 31,
//     "Major": "厨",
//     "Minor": "廚"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 31,
//     "Major": "旁",
//     "Minor": "旁"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 31,
//     "Major": "边",
//     "Minor": "邊"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 31,
//     "Major": "卧",
//     "Minor": "臥"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 31,
//     "Major": "室",
//     "Minor": "室"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 31,
//     "Major": "柜",
//     "Minor": "櫃"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 31,
//     "Major": "架",
//     "Minor": "架"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 32,
//     "Major": "各",
//     "Minor": "各"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 32,
//     "Major": "位",
//     "Minor": "位"
//   },
//   { // 不知為何 LearningUnit 裡面 有一個 empty，只好硬寫去支援   Tim18.01.02
//     "Volume": 3,
//     "Lesson": 32,
//     "Major": "",
//     "Minor": ""
//   },
//   {
//     "Volume": 3,
//     "Lesson": 32,
//     "Major": "栋",
//     "Minor": "棟"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 32,
//     "Major": "场",
//     "Minor": "場"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 32,
//     "Major": "共",
//     "Minor": "共"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 32,
//     "Major": "式",
//     "Minor": "式"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 32,
//     "Major": "体",
//     "Minor": "體"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 32,
//     "Major": "育",
//     "Minor": "育"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 32,
//     "Major": "安",
//     "Minor": "安"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 32,
//     "Major": "静",
//     "Minor": "靜"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 32,
//     "Major": "处",
//     "Minor": "處"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 32,
//     "Major": "树",
//     "Minor": "樹"
//   },
//   // {
//   //   "Volume": 3,
//   //   "Lesson": 32,
//   //   "Major": "草",
//   //   "Minor": "草"
//   // },
//   {
//     "Volume": 3,
//     "Lesson": 33,
//     "Major": "社",
//     "Minor": "社"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 33,
//     "Major": "区",
//     "Minor": "區"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 33,
//     "Major": "报",
//     "Minor": "報"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 33,
//     "Major": "图",
//     "Minor": "圖"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 33,
//     "Major": "银",
//     "Minor": "銀"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 33,
//     "Major": "行",
//     "Minor": "行"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 33,
//     "Major": "邮",
//     "Minor": "郵"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 33,
//     "Major": "局",
//     "Minor": "局"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 33,
//     "Major": "院",
//     "Minor": "院"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 33,
//     "Major": "方",
//     "Minor": "方"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 33,
//     "Major": "便",
//     "Minor": "便"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 33,
//     "Major": "邻",
//     "Minor": "鄰"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 33,
//     "Major": "居",
//     "Minor": "居"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 33,
//     "Major": "善",
//     "Minor": "善"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 34,
//     "Major": "邀",
//     "Minor": "邀"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 34,
//     "Major": "喂",
//     "Minor": "喂"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 34,
//     "Major": "等",
//     "Minor": "等"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 34,
//     "Major": "应",
//     "Minor": "應"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 34,
//     "Major": "该",
//     "Minor": "該"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 34,
//     "Major": "错",
//     "Minor": "錯"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 34,
//     "Major": "烤",
//     "Minor": "烤"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 34,
//     "Major": "肉",
//     "Minor": "肉"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 34,
//     "Major": "需",
//     "Minor": "需"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 34,
//     "Major": "备",
//     "Minor": "備"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 34,
//     "Major": "活",
//     "Minor": "活"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 34,
//     "Major": "诉",
//     "Minor": "訴"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 34,
//     "Major": "地",
//     "Minor": "地"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 34,
//     "Major": "址",
//     "Minor": "址"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 35,
//     "Major": "片",
//     "Minor": "片"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 35,
//     "Major": "功",
//     "Minor": "功"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 35,
//     "Major": "夫",
//     "Minor": "夫"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 35,
//     "Major": "情",
//     "Minor": "情"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 35,
//     "Major": "思",
//     "Minor": "思"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 35,
//     "Major": "变",
//     "Minor": "變"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 35,
//     "Major": "近",
//     "Minor": "近"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 35,
//     "Major": "部",
//     "Minor": "部"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 35,
//     "Major": "轻",
//     "Minor": "輕"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 35,
//     "Major": "松",
//     "Minor": "鬆"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 35,
//     "Major": "尝",
//     "Minor": "嘗"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 35,
//     "Major": "菜",
//     "Minor": "菜"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 35,
//     "Major": "鸡",
//     "Minor": "雞"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 36,
//     "Major": "光",
//     "Minor": "光"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 36,
//     "Major": "临",
//     "Minor": "臨"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 36,
//     "Major": "冰",
//     "Minor": "冰"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 36,
//     "Major": "杯",
//     "Minor": "杯"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 36,
//     "Major": "单",
//     "Minor": "單"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 36,
//     "Major": "味",
//     "Minor": "味"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 36,
//     "Major": "份",
//     "Minor": "份"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 36,
//     "Major": "酸",
//     "Minor": "酸"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 36,
//     "Major": "甜",
//     "Minor": "甜"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 36,
//     "Major": "咸",
//     "Minor": "鹹"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 36,
//     "Major": "辣",
//     "Minor": "辣"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 36,
//     "Major": "饱",
//     "Minor": "飽"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 36,
//     "Major": "糖",
//     "Minor": "糖"
//   },
//   {
//     "Volume": 3,
//     "Lesson": 36,
//     "Major": "醋",
//     "Minor": "醋"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 37,
//     "Major": "展",
//     "Minor": "展"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 37,
//     "Major": "子",
//     "Minor": "子"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 37,
//     "Major": "品",
//     "Minor": "品"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 37,
//     "Major": "空",
//     "Minor": "空"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 37,
//     "Major": "当",
//     "Minor": "當"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 37,
//     "Major": "然",
//     "Minor": "然"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 37,
//     "Major": "出",
//     "Minor": "出"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 37,
//     "Major": "款",
//     "Minor": "款"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 37,
//     "Major": "于",
//     "Minor": "於"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 37,
//     "Major": "正",
//     "Minor": "正"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 37,
//     "Major": "免",
//     "Minor": "免"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 37,
//     "Major": "入",
//     "Minor": "入"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 37,
//     "Major": "票",
//     "Minor": "票"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 38,
//     "Major": "软",
//     "Minor": "軟"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 38,
//     "Major": "帮",
//     "Minor": "幫"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 38,
//     "Major": "量",
//     "Minor": "量"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 38,
//     "Major": "站",
//     "Minor": "站"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 38,
//     "Major": "礼",
//     "Minor": "禮"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 38,
//     "Major": "折",
//     "Minor": "折"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 38,
//     "Major": "格",
//     "Minor": "格"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 38,
//     "Major": "比",
//     "Minor": "比"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 38,
//     "Major": "查",
//     "Minor": "查"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 38,
//     "Major": "实",
//     "Minor": "實"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 38,
//     "Major": "利",
//     "Minor": "利"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 38,
//     "Major": "付",
//     "Minor": "付"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 38,
//     "Major": "卡",
//     "Minor": "卡"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 39,
//     "Major": "庆",
//     "Minor": "慶"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 39,
//     "Major": "蛋",
//     "Minor": "蛋"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 39,
//     "Major": "糕",
//     "Minor": "糕"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 39,
//     "Major": "算",
//     "Minor": "算"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 39,
//     "Major": "特",
//     "Minor": "特"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 39,
//     "Major": "属",
//     "Minor": "屬"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 39,
//     "Major": "主",
//     "Minor": "主"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 39,
//     "Major": "龙",
//     "Minor": "龍"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 39,
//     "Major": "象",
//     "Minor": "象"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 39,
//     "Major": "孩",
//     "Minor": "孩"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 39,
//     "Major": "性",
//     "Minor": "性"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 39,
//     "Major": "忠",
//     "Minor": "忠"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 39,
//     "Major": "诚",
//     "Minor": "誠"
//   },
//   {
//     "Volume": 4,
//     "Lesson": 39,
//     "Major": "牛",
//     "Minor": "牛"
//   },
//   {"Volume": 4,"Lesson": 40,"Major": "节","Minor": "節"},{"Volume": 4,"Lesson": 40,"Major": "传","Minor": "傳"},{"Volume": 4,"Lesson": 40,"Major": "底","Minor": "底"},{"Volume": 4,"Lesson": 40,"Major": "全","Minor": "全"},{"Volume": 4,"Lesson": 40,"Major": "夜","Minor": "夜"},{"Volume": 4,"Lesson": 40,"Major": "闹","Minor": "鬧"},{"Volume": 4,"Lesson": 40,"Major": "提","Minor": "提"},{"Volume": 4,"Lesson": 40,"Major": "食","Minor": "食"},{"Volume": 4,"Lesson": 40,"Major": "自","Minor": "自"},{"Volume": 4,"Lesson": 40,"Major": "己","Minor": "己"},{"Volume": 4,"Lesson": 40,"Major": "举","Minor": "舉"},{"Volume": 4,"Lesson": 40,"Major": "例","Minor": "例"},{"Volume": 4,"Lesson": 40,"Major": "饼","Minor": "餅"},{"Volume": 4,"Lesson": 40,"Major": "挂","Minor": "掛"},{"Volume": 4,"Lesson": 40,"Major": "灯","Minor": "燈"},
//   {"Volume": 4,"Lesson": 41,"Major": "亲","Minor": "親"},{"Volume": 4,"Lesson": 41,"Major": "爱","Minor": "愛"},{"Volume": 4,"Lesson": 41,"Major": "消","Minor": "消"},{"Volume": 4,"Lesson": 41,"Major": "复","Minor": "復"},{"Volume": 4,"Lesson": 41,"Major": "常","Minor": "常"},{"Volume": 4,"Lesson": 41,"Major": "发","Minor": "發"},{"Volume": 4,"Lesson": 41,"Major": "夏","Minor": "夏"},{"Volume": 4,"Lesson": 41,"Major": "冬","Minor": "冬"},{"Volume": 4,"Lesson": 41,"Major": "季","Minor": "季"},{"Volume": 4,"Lesson": 41,"Major": "被","Minor": "被"},{"Volume": 4,"Lesson": 41,"Major": "让","Minor": "讓"},{"Volume": 4,"Lesson": 41,"Major": "失","Minor": "失"},{"Volume": 4,"Lesson": 41,"Major": "停","Minor": "停"},{"Volume": 4,"Lesson": 41,"Major": "春","Minor": "春"},{"Volume": 4,"Lesson": 41,"Major": "秋","Minor": "秋"},
//   {"Volume": 4,"Lesson": 42,"Major": "张","Minor": "張"},{"Volume": 4,"Lesson": 42,"Major": "随","Minor": "隨"},{"Volume": 4,"Lesson": 42,"Major": "约","Minor": "約"},{"Volume": 4,"Lesson": 42,"Major": "识","Minor": "識"},{"Volume": 4,"Lesson": 42,"Major": "择","Minor": "擇"},{"Volume": 4,"Lesson": 42,"Major": "铁","Minor": "鐵"},{"Volume": 4,"Lesson": 42,"Major": "减","Minor": "減"},{"Volume": 4,"Lesson": 42,"Major": "少","Minor": "少"},{"Volume": 4,"Lesson": 42,"Major": "污","Minor": "污"},{"Volume": 4,"Lesson": 42,"Major": "染","Minor": "染"},{"Volume": 4,"Lesson": 42,"Major": "刚","Minor": "剛"},{"Volume": 4,"Lesson": 42,"Major": "才","Minor": "才"},{"Volume": 4,"Lesson": 42,"Major": "收","Minor": "收"},{"Volume": 4,"Lesson": 42,"Major": "拾","Minor": "拾"},{"Volume": 4,"Lesson": 42,"Major": "瓶","Minor": "瓶"},
//   {"Volume": 4,"Lesson": 43,"Major": "头","Minor": "頭"},{"Volume": 4,"Lesson": 43,"Major": "疼","Minor": "疼"},{"Volume": 4,"Lesson": 43,"Major": "咳","Minor": "咳"},{"Volume": 4,"Lesson": 43,"Major": "烧","Minor": "燒"},{"Volume": 4,"Lesson": 43,"Major": "冒","Minor": "冒"},{"Volume": 4,"Lesson": 43,"Major": "挺","Minor": "挺"},{"Volume": 4,"Lesson": 43,"Major": "严","Minor": "嚴"},{"Volume": 4,"Lesson": 43,"Major": "针","Minor": "針"},{"Volume": 4,"Lesson": 43,"Major": "效","Minor": "效"},{"Volume": 4,"Lesson": 43,"Major": "药","Minor": "藥"},{"Volume": 4,"Lesson": 43,"Major": "苦","Minor": "苦"},{"Volume": 4,"Lesson": 43,"Major": "坚","Minor": "堅"},{"Volume": 4,"Lesson": 43,"Major": "持","Minor": "持"},{"Volume": 4,"Lesson": 43,"Major": "受","Minor": "受"},{"Volume": 4,"Lesson": 43,"Major": "康","Minor": "康"},
//   {"Volume": 4,"Lesson": 44,"Major": "饮","Minor": "飲"},{"Volume": 4,"Lesson": 44,"Major": "健","Minor": "健"},{"Volume": 4,"Lesson": 44,"Major": "增","Minor": "增"},{"Volume": 4,"Lesson": 44,"Major": "身","Minor": "身"},{"Volume": 4,"Lesson": 44,"Major": "油","Minor": "油"},{"Volume": 4,"Lesson": 44,"Major": "注","Minor": "注"},{"Volume": 4,"Lesson": 44,"Major": "状","Minor": "狀"},{"Volume": 4,"Lesson": 44,"Major": "况","Minor": "況"},{"Volume": 4,"Lesson": 44,"Major": "响","Minor": "響"},{"Volume": 4,"Lesson": 44,"Major": "规","Minor": "規"},{"Volume": 4,"Lesson": 44,"Major": "律","Minor": "律"},{"Volume": 4,"Lesson": 44,"Major": "精","Minor": "精"},{"Volume": 4,"Lesson": 44,"Major": "神","Minor": "神"},{"Volume": 4,"Lesson": 44,"Major": "锻","Minor": "鍛"},{"Volume": 4,"Lesson": 44,"Major": "炼","Minor": "煉"},
//   {"Volume": 4,"Lesson": 45,"Major": "演","Minor": "演"},{"Volume": 4,"Lesson": 45,"Major": "陪","Minor": "陪"},{"Volume": 4,"Lesson": 45,"Major": "哇","Minor": "哇"},{"Volume": 4,"Lesson": 45,"Major": "通","Minor": "通"},{"Volume": 4,"Lesson": 45,"Major": "申","Minor": "申"},{"Volume": 4,"Lesson": 45,"Major": "请","Minor": "請"},{"Volume": 4,"Lesson": 45,"Major": "拿","Minor": "拿"},{"Volume": 4,"Lesson": 45,"Major": "幸","Minor": "幸"},{"Volume": 4,"Lesson": 45,"Major": "巧","Minor": "巧"},{"Volume": 4,"Lesson": 45,"Major": "结","Minor": "結"},{"Volume": 4,"Lesson": 45,"Major": "束","Minor": "束"},{"Volume": 4,"Lesson": 45,"Major": "口","Minor": "口"},{"Volume": 4,"Lesson": 45,"Major": "目","Minor": "目"},
//   {"Volume": 4,"Lesson": 46,"Major": "录","Minor": "錄"},{"Volume": 4,"Lesson": 46,"Major": "世","Minor": "世"},{"Volume": 4,"Lesson": 46,"Major": "界","Minor": "界"},{"Volume": 4,"Lesson": 46,"Major": "闻","Minor": "聞"},{"Volume": 4,"Lesson": 46,"Major": "古","Minor": "古"},{"Volume": 4,"Lesson": 46,"Major": "迹","Minor": "蹟"},{"Volume": 4,"Lesson": 46,"Major": "力","Minor": "力"},{"Volume": 4,"Lesson": 46,"Major": "代","Minor": "代"},{"Volume": 4,"Lesson": 46,"Major": "伟","Minor": "偉"},{"Volume": 4,"Lesson": 46,"Major": "诗","Minor": "詩"},{"Volume": 4,"Lesson": 46,"Major": "背","Minor": "背"},{"Volume": 4,"Lesson": 46,"Major": "首","Minor": "首"},{"Volume": 4,"Lesson": 46,"Major": "懂","Minor": "懂"},{"Volume": 4,"Lesson": 46,"Major": "著","Minor": "著"},
//   {"Volume": 4,"Lesson": 47,"Major": "检","Minor": "檢"},{"Volume": 4,"Lesson": 47,"Major": "尊","Minor": "尊"},{"Volume": 4,"Lesson": 47,"Major": "敬","Minor": "敬"},{"Volume": 4,"Lesson": 47,"Major": "长","Minor": "長"},{"Volume": 4,"Lesson": 47,"Major": "信","Minor": "信"},{"Volume": 4,"Lesson": 47,"Major": "改","Minor": "改"},{"Volume": 4,"Lesson": 47,"Major": "遍","Minor": "遍"},{"Volume": 4,"Lesson": 47,"Major": "义","Minor": "義"},{"Volume": 4,"Lesson": 47,"Major": "送","Minor": "送"},{"Volume": 4,"Lesson": 47,"Major": "照","Minor": "照"},{"Volume": 4,"Lesson": 47,"Major": "适","Minor": "適"},{"Volume": 4,"Lesson": 47,"Major": "合","Minor": "合"},{"Volume": 4,"Lesson": 47,"Major": "走","Minor": "走"},{"Volume": 4,"Lesson": 47,"Major": "丢","Minor": "丟"},{"Volume": 4,"Lesson": 47,"Major": "感","Minor": "感"},
//   {"Volume": 4,"Lesson": 48,"Major": "玩","Minor": "玩"},{"Volume": 4,"Lesson": 48,"Major": "所","Minor": "所"},{"Volume": 4,"Lesson": 48,"Major": "观","Minor": "觀"},{"Volume": 4,"Lesson": 48,"Major": "交","Minor": "交"},{"Volume": 4,"Lesson": 48,"Major": "订","Minor": "訂"},{"Volume": 4,"Lesson": 48,"Major": "连","Minor": "連"},{"Volume": 4,"Lesson": 48,"Major": "馆","Minor": "館"},{"Volume": 4,"Lesson": 48,"Major": "赏","Minor": "賞"},{"Volume": 4,"Lesson": 48,"Major": "景","Minor": "景"},{"Volume": 4,"Lesson": 48,"Major": "丽","Minor": "麗"},{"Volume": 4,"Lesson": 48,"Major": "原","Minor": "原"},{"Volume": 4,"Lesson": 48,"Major": "湖","Minor": "湖"},{"Volume": 4,"Lesson": 48,"Major": "山","Minor": "山"},{"Volume": 4,"Lesson": 48,"Major": "城","Minor": "城"},{"Volume": 4,"Lesson": 48,"Major": "市","Minor": "市"}
// ]

const gobjPreludeMenu = {
  "Ver_Current": [
        {"ChapterID": 1,"Name": "1. Introduction to Chinese","MajorFileName": "Chapter1_Major.html","MinorFileName": "Chapter1_Minor.html","SectionList": [{"SectionID": "p1","Name": "What Is Chinese?"},{"SectionID": "p2","Name": "What Are Chinese Dialects?"},{"SectionID": "p3","Name": "What Are Chinese Characters?"},{"SectionID": "p4","Name": "How Do You Write Chinese Characters?"},{"SectionID": "p5","Name": "How Are Characters Structured?"},{"SectionID": "p6","Name": "What Are Strokes and Stroke Order?"},{"SectionID": "p7","Name": "How Can I Remember a Character’s Stroke Order?"}]},
        {"ChapterID": 2,"Name": "2. Introduction to Pinyin and Pronunciation","MajorFileName": "Chapter2_Major.html","MinorFileName": "Chapter2_Minor.html","SectionList": [{"SectionID": "p1","Name": "What is Pinyin?"},{"SectionID": "p2","Name": "How Can We Use Pinyin to Learn Pronunciation?"},{"SectionID": "p3","Name": "How Do I Pronounce Mandarin Initials?"},{"SectionID": "p4","Name": "How Do I Pronounce Mandarin Finals?"},{"SectionID": "p5","Name": "What Are Some Tips for Writing Pinyin?"}]},
        {"ChapterID": 3,"Name": "3. Introduction to Tones","MajorFileName": "Chapter3_Major.html","MinorFileName": "Chapter3_Minor.html","SectionList": [{"SectionID": "p1","Name": "What Are Tones?"},{"SectionID": "p2","Name": "How Do I Say Tones Correctly?"},{"SectionID": "p3","Name": "What is Tone Change?"},{"SectionID": "p4","Name": "When Do We Use Neutral Tone?"}]},
        {"ChapterID": 4,"Name": "4. Introduction to Chinese Punctuation and Grammar","MajorFileName": "Chapter4_Major.html","MinorFileName": "Chapter4_Minor.html","SectionList": [{"SectionID": "p1","Name": "Is Punctuation Different in Chinese?"},{"SectionID": "p2","Name": "What Do the Grammar Abbreviations Stand For?"},{"SectionID": "p3","Name": "What Are Some Basic Chinese Grammar Rules?"}]},
        {"ChapterID": 5,"Name": "5. Discovering Chinese Pro’s Structure","MajorFileName": "Chapter5_Major.html","MinorFileName": "Chapter5_Minor.html","SectionList": [{"SectionID": "p1","Name": "How Are Discovering Chinese Pro Lessons Structured?"},{"SectionID": "p2","Name": "How Do School Accounts Work?"}]},
        {"ChapterID": 6,"Name": "6. Introduction to Classroom Expressions","MajorFileName": "Chapter6_Major.html","MinorFileName": "Chapter6_Minor.html","SectionList": [{"SectionID": "p1","Name": "What Are Some Common Teacher Expressions?"},{"SectionID": "p2","Name": "What Are Some Common Student Expressions?"}]},
        {"ChapterID": 7,"Name": "7. Scope and Sequence","MajorFileName": "Chapter7_Major.html","MinorFileName": "Chapter7_Minor.html","SectionList": [{"SectionID": "p1","Name": "Scope and Sequence"}]},
        {"ChapterID": 8,"Name": "8. Introduction to the Main Characters","MajorFileName": "Chapter9_Major.html","MinorFileName": "Chapter9_Minor.html","SectionList": [{"SectionID": "p1","Name": "Who Are the Characters in the DCP Stories?"}]}
    ]
}

// const gLoginFlag = {
//     "HasQueryString": null, // 必要條件 
//     "PageIsInTheApp": null, // 必要條件
//     "LocalStorageContainLastAccountID": null, // 必要條件
//     "LocalStorageContainCredentialIsValid": null, // 必要條件
//     "LocalStorageContainLastLoginStatusIsOAuth": null, // 必要條件

//     "LocalStorageContainLastLoginStatusIsOAuthAndAppleSignIn": null, // 非必要條件
//     "LocalStorageContainLastAccountID_IsTheSameAs_CurrentAccountID": null, // 非必要條件
//     "NavigatorOnLine": null // 非必要條件
// }

const gEmailVerifyEnum = {
    "None": -1, // 初始值 無指定
    "NotVerify": 0, // CMS定義 沒有驗證
    "Verified": 1 // CMS定義 驗證過
}

export {
    gConst,
    gSession,
    
    // gWSServerTypeEnum,
    // gDeviceType4LogTraceEnum,
    // gBrowserTypeEnum,
    gAccPreferenceTypeEnum,
    gLangTypeEnum,
    // gContentVerTypeEnum,
    // gBookCategoryIDEnum,
    gButtonTypeEnum,
    gLUUserDataTypeEnum,
    gDataStatusFromAppEnum,
    gDataStatusFromAppIAPEnum,
    gResultCodeForAppInAppPurchaseSwiftUIEnum,
    gAssignReportStatusEnum,
    gEventModeEnum,
    gSwipeDirectionEnum,
    gChangeAnimationTypeEnum,
    // gOrientationModeEnum,
    gSettingsFuncIndexEnum,
    gCSSIndexEnum,
    // gSyncEnum,
    gSRDifficultyEnum,
    gNewAssignmentStatusEnum,
    // gSRRecordModeEnum,
    gDeviceType4DisplayEnum,
    gVideoTypeEnum,
    gReminderTypeEnum,
    gLUChangePageStatusEnum,
    // gEntranceTypeEnum,
    gGlossaryBackStatusEnum,
    gDCPJsonEnum,
    gToolbarStatusEnum,
    gDCPLUEnum,
    gAnsDataTypeEnum,
    gQuestionTypeEnum,
    gAuthorizedSubscriptionTypeEnum,
    gPracticeLUIndexEnum,
    // gFileTypeEnum,
    gLoginAfterStatusEnum,
    gResourceTypeEnum,
    gAudioStatusEnum,
    gComponentFuncEntry,
    gAppURLSchemes,
    gAppiTunesURL,
    garrGradeLevel,
    garrLUAllAnswer,
    garrPracticeLU,
    garrDCPLUSwipeSeq,
    garrCountry,
    // garrTimeZone,
    // garrCharacters,
    gobjPreludeMenu,
    // gLoginFlag,
    gDateTimeFormatEnum,
    gEmailVerifyEnum
}